import React from "react";
import PropTypes from "prop-types";
import { withOktaAuth } from "@okta/okta-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExclamationTriangle,
  faInfoCircle,
  faLock,
} from "@fortawesome/free-solid-svg-icons";
import { Typography } from "@material-ui/core";
import Link from '@material-ui/core/Link';
import { useHistory } from "react-router-dom";
import { styles } from "./styles";
import { useTranslation } from "react-i18next";

const {
  container,
  messageContainer,
  messagePrimary,
  messageSecondary,
  messageLink,
  icon,
} = styles;

const ErrorMessage = (props) => {
  const { messageType, message, secondaryMessage, tryAgainLabel } = props;
  let history = useHistory();
  const { t } = useTranslation();
  let iconType = faExclamationTriangle;

  switch (messageType) {
    case "security":
      iconType = faLock;
      break;
    case "info":
      iconType = faInfoCircle;
      break;
    default:
      break;
  }

  return (
    <div style={container}>
      <div style={messageContainer}>
        <FontAwesomeIcon icon={iconType} style={icon} />
        <Typography style={messagePrimary}>{message || t("messages.common.errors.generic")}</Typography>
        {secondaryMessage && <Typography style={messageSecondary}>{secondaryMessage}</Typography>}
        <Link onClick={history.goBack} variant="inherit">
          <Typography style={messageLink}>{tryAgainLabel || t("labels.common.tryAgain")}</Typography>
        </Link>
      </div>
    </div>
  );
};

ErrorMessage.propTypes = {
  auth: PropTypes.object,
  messageType: PropTypes.oneOf(["error", "security", "info"]),
  message: PropTypes.string,
  secondaryMessage: PropTypes.string,
  showAppBar: PropTypes.bool,
  environmentName: PropTypes.string,
  fullName: PropTypes.string,
};

ErrorMessage.defaultProps = {
  auth: null,
  messageType: "error",
  message: "",
  secondaryMessage: "",
  showAppBar: false,
  environmentName: "",
  fullName: "",
};

export default withOktaAuth(ErrorMessage);
